import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Login from '../Popups/Login';
import CallReq from '../Popups/CallReq';
import '../popup.css';

const Navbar = ({ roleo, usero }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenCall, setIsOpenCall] = useState(false);
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  const togglePopupCall = () => {
    setIsOpenCall(!isOpenCall);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload(false);
    navigate('/');
  };

  return (
    <div className='navbar'>
      <div className='nav-left'>
        <div className='div-logo'>
          <Link to='/'>
            <img src='/icons/logo.png' alt='logo' />
          </Link>
        </div>
        <ul>
          <li>
            <Link
              to='/doctors'
              className={location.pathname === '/doctors' ? 'active' : ''}
            >
              Find Doctors
            </Link>
          </li>
          <li>
            <Link
              to='/hospitals'
              className={location.pathname === '/hospitals' ? 'active' : ''}
            >
              Find Hospitals
            </Link>
          </li>
          <li>
            <Link
              to='/labtests'
              className={location.pathname === '/labtests' ? 'active' : ''}
            >
              Lab Test
            </Link>
          </li>
          <li>
            <Link
              to='/about'
              className={location.pathname === '/about' ? 'active' : ''}
            >
              About Us
            </Link>
          </li>
          <li>
            <Link
              to='/period-tracker'
              className={location.pathname === '/period-tracker' ? 'active' : ''}
            >
              Period Tracker
            </Link>
          </li>
        </ul>
      </div>

      <div className='nav-right'>
        {usero ? (
          <>
            {roleo === 'user' && (
              <div className='btn-group'>
                <button
                  type='button'
                  className='btn btn-danger dropdown-toggle'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                >
                  {usero}
                </button>
                <div className='dropdown-menu dpm'>
                  <Link className='dropdown-item' to='/myprofile'>My Appointments</Link>
                  <Link className='dropdown-item' to='/myprofile'>My Online Consultations</Link>
                  <Link className='dropdown-item' to='/myprofile'>My Lab Tests</Link>
                  <Link className='dropdown-item' to='/myprofile'>My Oxygen Orders</Link>
                  <Link className='dropdown-item' to='/myprofile'>My Blood Tests</Link>
                  <Link className='dropdown-item' to='/myprofile'>My Medicines</Link>
                  <div className='dropdown-divider'></div>
                  <button onClick={handleLogout} className='dropdown-item'>Logout</button>
                </div>
              </div>
            )}
            {roleo === 'admin' && (
              <div className='btn-group'>
                <button
                  type='button'
                  className='btn btn-danger dropdown-toggle'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
                >
                  {usero}
                </button>
                <div className='dropdown-menu dpm'>
                  <Link className='dropdown-item' to='/adminpanel'>View Appointments</Link>
                  <Link className='dropdown-item' to='/adminpanel'>View Consultations</Link>
                  <Link className='dropdown-item' to='/adminpanel'>View Call Requests</Link>
                  <Link className='dropdown-item' to='/adminpanel'>View Blood Requests</Link>
                  <Link className='dropdown-item' to='/adminpanel'>View Oxygen Requests</Link>
                  <Link className='dropdown-item' to='/adminpanel'>View Medicine Requests</Link>
                  <Link className='dropdown-item' to='/adminpanel'>View Lab Test Requests</Link>
                  <div className='dropdown-divider'></div>
                  <button onClick={handleLogout} className='dropdown-item'>Logout</button>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <a className='reqs' onClick={togglePopupCall} href='#'>Request Call</a>
            <a onClick={togglePopup} className='login-btn' href='#'>Login / Signup</a>
          </>
        )}
      </div>

      {isOpenCall && (
        <div className='pop-overlay'>
          <div className='popup'>
            <CallReq />
            <button className='cls-btn' onClick={togglePopupCall}>
              <i className='fa-solid fa-xmark'></i>
            </button>
          </div>
        </div>
      )}

      {isOpen && (
        <div className='pop-overlay'>
          <div className='popup'>
            <Login />
            <button className='cls-btn' onClick={togglePopup}>
              <i className='fa-solid fa-xmark'></i>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
